import api from './api';
import { TagsResponse, Tag } from '../types';

export interface TagFilters {
  search?: string;
  hasEmail?: boolean;
}

export const tagService = {
  async getTags(filters: TagFilters = {}): Promise<TagsResponse> {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        params.append(key, value.toString());
      }
    });

    const response = await api.get<TagsResponse>(`/tags?${params}`);
    return response.data;
  },

  async createTag(name: string, email?: string): Promise<Tag> {
    const response = await api.post<Tag>('/tags', { name, email });
    return response.data;
  },

  async updateTag(tagId: number, updates: { name?: string; email?: string }): Promise<Tag> {
    const response = await api.put<Tag>(`/tags/${tagId}`, updates);
    return response.data;
  },


  async deleteTag(tagId: number): Promise<void> {
    await api.delete(`/tags/${tagId}`);
  },

  async sendEmail(tagId: number, customMessage?: string): Promise<{ success: boolean; message: string }> {
    const response = await api.post(`/tags/${tagId}/send-email`, {
      customMessage: customMessage || ''
    });
    return response.data;
  },
};